export enum BrandLocation {
  GEORGETOWN = 'georgetown',
  RUTGERS = 'rutgers',
}

export const BRAND_LOCATION_STORAGE_KEY = 'brandLocation';
